import { displayFnWrapperArrayFlatter } from './common-display-fn';

export const emeaYearRenovatedDisplayFunctions = {
  419: {
    // 419 - Year Renovated (Poland & Finland)
    displayFn: displayFnWrapperArrayFlatter,
  },
  429: {
    // 429 - Year Renovated (Italy)
    displayFn: displayFnWrapperArrayFlatter,
  },
  506: {
    // 506 - Year Renovated (Norway)
    displayFn: displayFnWrapperArrayFlatter,
  },
  516: {
    // 516 - Year Renovated (Norway)
    displayFn: displayFnWrapperArrayFlatter,
  },
  496: {
    // 496 - Year Renovated (Sweden)
    displayFn: displayFnWrapperArrayFlatter,
  },
};
